import { compose } from 'recompose';

import ClientCreate from './ClientCreate';

const enhance = compose();

export default enhance(ClientCreate);
